import React, { useState } from 'react';

import { CopyToClipboard } from 'react-copy-to-clipboard';

import WithdrawalSuccessTimerCon from "./../../../Components/Common/WithdrawalSuccessTimer";

import translate from "./../../../lib/translate/TranslateJs";



function WithdrawalSuccessTimer(props) {
    const [isCopySuccess, setIsCopySuccess] = useState(false)

    return (
        <WithdrawalSuccessTimerCon
            {...props}
            RemainTime={(propCon) => (
                <>
                    <div className="withdrawalSuccessModal">
                        <div className="successContent">
                            <div className="headerText">
                                {/* <div>
                                    <img src={`${process.env.BASE_PATH}/img/svg/Success_1.svg`} alt="success" />
                                </div> */}
                                <div className="successIcon" />
                                <p>{translate("成功提交提款")()}</p>
                            </div>
                            <div className="status">
                                <div className="statusItem">
                                    <label className="completed">{translate("发送订单成功")()}</label>
                                    <span>{props.type==="LB" ? translate("进行中")() : translate("进行中(Crypto)")()}</span>
                                </div>
                                <div className="statusItem">
                                    <label className="processing">{translate("预计在 <#0#> 分钟内")(propCon.remainingTime)}</label>
                                </div>
                            </div>
                            <div className="transactionDetail">
                                <div className="amount">
                                    <label>{translate("提款金额")()}</label>
                                    <p>{translate("￥ <#0#>")(props.depositMoney)}</p>
                                </div>
                                <div className="transactionID">
                                    <label>{translate("交易代码")()}</label>
                                    <div className="rightBox">
                                        <span>{props.transactionId}</span>
                                        <CopyToClipboard
                                            text={props.transactionId}
                                            onCopy={()=>{
                                                setIsCopySuccess(true)
                                                propCon.onCopy()
                                            }}
                                        >
                                            <div className="copyIcon"/>
                                        </CopyToClipboard>
                                        {isCopySuccess && <div className='copySuccessIcon'/>}
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <p className="remark">
                            {translate( props.type==="LB" ? "正在处理您的提款，有任何疑问请联系客服(desktop)" : "注：此汇率仅供参考，交易将按提现时的实际汇率计算。")()}
                        </p>
                        <div className="buttonBox">
                            <button className="primary-button" onClick={propCon.goRecord}>{translate("查询交易记录")()}</button>
                            <button className="ghost-button" onClick={props.goHome}>{translate("返回提款页面")()}</button>
                        </div>
                    </div>
                    <div className="spaceBox" />
                </>
            )}
        />
    );
}


export default WithdrawalSuccessTimer;

